import gql from 'graphql-tag';


export default
gql `mutation updateActivity($input: UpdateActivityInput!){
		updateActivity(input: $input){
            id
            username
            actDate
            activityType
            value
            intensity
            notes
		}
	}
`;


// WEBPACK FOOTER //
// ./src/components/mutations/UpdateActivityMutation.js